import React from 'react';
import BillingAddressCardBody from './BillingAddressCardBody.jsx';
import styled from 'styled-components';

const BillingAddressCardSelect = (props) => {
  const {
    id,
    onDefineAsSelected,
    isDefault,
    isSelected,
    cardTitle,
    editable,
    businessName,
    lastName,
    firstName,
    address,
    postalCode,
    city,
    country,
    taxId,
    requestsHotelsId,
    connectedAs
  } = props;

  return (
    <Wrapper 
      onClick={() => onDefineAsSelected(id)} 
      className={ context == 'congress' ?
        "billing-address-card billing-address-card-select col-12 mb-3 "
        :
        "billing-address-card billing-address-card-select col-12 col-md-6 mb-3 "
      }
    >
      <div className={isSelected == 1 ? 'card selected shadow-sm '+context : 'card shadow-sm '+context}>
        <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-subtitle text-gc-dark-blue font-weight-bold m-0">{cardTitle}</h6>
            <div>
              { context == "congress" ? (
                <a
                  className="m-0 btn btn-light btn-sm rounded-circle btn-edit-payment-infos"
                  data-toggle="modal"
                  data-target={"#modalEditPaymentsInfos" + id}
                >
                  <i className="fas fa-edit text-gc-dark-blue"></i>
                </a>
              ) : (
                  editable && (!requestsHotelsId || (requestsHotelsId && connectedAs == 'clients')) && (  
                    <a 
                      href="#"
                      data-part="+"
                      data-target={connected_as + '//account/billing_address/edit/' + id + '/' + membres_id}  
                      className="m-0 btn btn-light btn-sm rounded-circle js-nav get_part_link"
                    >
                      <i className="fas fa-edit text-gc-dark-blue"></i>
                    </a>
                  )
                )
              }                 
            </div>
        </div>

        <BillingAddressCardBody
          businessName={businessName}
          lastName={lastName}
          firstName={firstName}
          address={address}
          postalCode={postalCode}
          city={city}
          country={country}
          taxId={taxId}
        />

      </div>   
    </Wrapper>
  );
}

export default BillingAddressCardSelect;

export const Wrapper = styled.div`
    cursor: pointer;

    .card {
        transition: .3s;
        -webkit-transition: .3s;
        -moz-transition: .3s;
        -ms-transition: .3s;
        -o-transition: .3s;
        
        &:hover, &.selected {
            border: 1px solid #F0672F;

            .card-header {
                h6 {
                    color: #F0672F!important;
                }
            }
        }        
    }

    .card.congress {
        &:hover, &.selected {
          border: 1px solid #439394;

          .card-header {
              h6 {
                  color: #439394 !important;
              }
          }
      }
    }
`